import banner from "../../assets/img/service-banner7.avif";
const data = [
  "Safe Decommissioning & Removal of obsolete or existing equipment to prepare for new installations",
  "High-Precision Datum Surveys & Alignment to guarantee exact positioning and machine calibration",
  "Foundation Engineering Support, including preparation of footings and detailed floor layout marking",
  "Structural Fixings & Heavy-Duty Drilling to secure machinery foundations and ensure stability",
  "Expert Logistics Management including secure storage, transportation, and site handling of equipment",
  "Heavy Lifting & Rigging using specialized cranes, hydraulic gantries, forklifts, and lifting systems tailored to aviation assets",
  "Mechanical Assembly & Rebuilds, incorporating the installation of safety guards and ancillary components",
  "Precision Alignment & Leveling to maximize machine performance and reduce wear",
  "Integration of Mechanical and Electrical Systems, including ducting, ventilation, and auxiliary services",
  "Custom Fabrication & Installation of access platforms, walkways, and floor plates for safe operations",
  "Rigorous Testing & Pre-Commissioning to validate equipment functionality and compliance",
  "Final Commissioning & Operational Handover conducted in close collaboration with clients and OEMs",
  "Comprehensive Training Programs for operational staff to ensure optimal use and maintenance of installed equipment",
  "Professional Project Documentation capturing every stage for future reference and compliance",
];
const InstallationIntegration = () => {
  return (
    <>
      <section className="serviceSection sectionPD">
        <div className="container">
          <div className="fisherman-content">
            <h3>
              Precision Installation, Integration & Commissioning Services for
              Aviation
            </h3>
          </div>

          <div className="serviceDetail">
            <div className="header">
              <img
                src={banner}
                alt="Precision Installation, Integration & Commissioning Services for Aviation"
                className="img-fluid"
                title="Precision Installation, Integration & Commissioning Services for Aviation"
              />
              <p>
                At GGAS Maintenance Tooling &amp; Equipments (GGAS), we
                specialize in delivering end-to-end installation, integration,
                commissioning, and training solutions tailored for aviation
                production machinery and mechanical infrastructure. Our deep
                industry expertise ensures complex projects are executed with
                precision, safety, and operational excellence.
              </p>
              <p>
                Comprehensive Solutions for Complex Installations From the
                installation of individual production machines to large-scale
                mechanical systems, our experienced team manages every stage of
                the process with meticulous attention to detail and industry
                best practices.
              </p>
            </div>
            <div className="body">
              <h4>Our Core Installation Capabilities:</h4>
              <ul>
                {data.map((item, i) => {
                  return <li key={i}>{item}</li>;
                })}
              </ul>
            </div>
            <div className="footer">
              <h4>Why Choose GGAS for Your Aviation Installations?</h4>
              <p>
                Our approach combines deep technical knowledge with aviation
                industry standards to deliver reliable, safe, and compliant
                installations that minimize downtime and operational risk. We
                partner with you to ensure your machinery and infrastructure
                perform flawlessly from day one.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default InstallationIntegration;
